import { connect } from 'react-redux'
import { selectTicketDraftAutomaticActions } from 'ducks/drafts/selectors'
import { doUpdateReplyDraft } from 'ducks/drafts/operations'
import { selectAccountPrefersReplyOpen } from 'selectors/app/selectAccountPreferences'

import Button from './view'

const select = state => ({
  prefersOpen: selectAccountPrefersReplyOpen(state),
  automaticActions: selectTicketDraftAutomaticActions(state),
})

const performFactory = (_, initialOwnProps) => {
  const { ticketId } = initialOwnProps

  return dispatch => ({
    resetAutomaticActionStatus: automaticActions => {
      const filteredAutomaticActions = automaticActions.filter(
        a => a.type !== 'status'
      )

      if (!filteredAutomaticActions.length) {
        return
      }

      dispatch(
        doUpdateReplyDraft(
          ticketId,
          'automaticActions',
          filteredAutomaticActions
        )
      )
    },
  })
}

export default connect(select, performFactory)(Button)
